import { __rest } from '../common/temp/node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { clsx } from '../../../../common/temp/node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js';
import { forwardRef } from 'react';
import { StyledWrapper, StyledDivider } from './Divider.styles.js';
const Divider = forwardRef((props, ref) => {
  var _a;
  const {
      orientation = 'horizontal',
      inline = false,
      className,
      customProps
    } = props,
    htmlProps = __rest(props, ["orientation", "inline", "className", "customProps"]);
  const _b = (_a = customProps === null || customProps === void 0 ? void 0 : customProps.divider) !== null && _a !== void 0 ? _a : {},
    {
      className: dividerClassName
    } = _b,
    customDividerProps = __rest(_b, ["className"]);
  return jsx(StyledWrapper, Object.assign({}, htmlProps, {
    className: className,
    role: "separator",
    "aria-orientation": orientation,
    ref: ref,
    orientation: orientation,
    inline: inline
  }, {
    children: jsx(StyledDivider, Object.assign({
      orientation: orientation
    }, customDividerProps, {
      className: clsx('Copan_Divider', dividerClassName)
    }), void 0)
  }), void 0);
});
Divider.displayName = 'ReactBase_Divider';
export { Divider };